import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=601d3ffb"
import script from "./locationList.ts?vue&type=script&lang=js&external"
export * from "./locationList.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports